export default {
  colors: {
    primary: '#ee3d46',
    background: '#194a51',
    shape: `#57b8c4`,
    title: `#ee3d46`,
    text: `#fff`,
    components: {
      blockquote: {
        background: `#57b8c4`,
        text: `#222`,
      },
    },
  },
};
